interface PermissionType {
  type: string;
  permissionType: number;
  information: number;
  price: number;
  display: number;
  soldOut: number;
  sort: number;
  recommendMenu: number;
  origin: number;
}

export interface MenuPermission {
  menuPermission: PermissionType[];
}

export interface MenuManageTabProps {
  storeId: string;
  setLoading: (loading: boolean) => void;
}

export interface CategoryCondition {
  beginDate: Date | string;
  beginTime: string;
  endDate: Date | string;
  endTime: string;
  displayType: string;
  day: ConditionDay[];
}

export interface ConditionDay {
  label: string;
  value: number;
}

export interface Categories {
  categoryCondition?: CategoryCondition;
  categoryID: string;
  categoryName: string;
  description: string;
  categoryFold: number;
  products: Product[];
}

export interface CategoryDetail extends CategoryCondition {
  categoryID?: string;
  categoryName: string;
  description: string;
  categoryFold: number;
  products?: Product[];
}

export interface Product {
  productID: string;
  name: string;
  status: string;
  isDisplay: string;
  recommend: string;
}

export type BottomPopupType = 'category' | 'menu' | 'optionGroup' | 'option';

export interface BottomPopupProps {
  isBottomPopup: boolean;
  onClickClose: () => void;
  type: BottomPopupType;
  clickedList: { id: string; title: string; optionGroupID?: string };
  onClickDelete?: () => void;
  onClickCopy?: () => void;
}

export interface OptionGroups {
  ID: number;
  isPriceOption: number;
  productID: number;
  selectType: number;
  limitChildren: number;
  isRequired: number;
  minSelect: number;
  maxSelect: number;
  status: number;
  storeID: number;
  isDisplay: number;
  title: string;
  children: OptionGroupChild[];
  products: any[];
  link?: number;
}

export interface OptionGroupChild {
  optionID: number;
  name: string;
  status: number;
  isDisplay: number;
  price: number;
  alcohol: number;
  maxSelect: number;
  externalMenuCode: null;
  isRequired?: number;
}
export interface OptParams {
  options: {
    title: string;
    isDisplay: number;
    selectType: number;
    children: { name: string; price: number; status: number; isDisplay: number }[];
    isPriceOption?: number;
    optionGroupID?: number;
    isRequired?: number;
    maxSelect?: number;
    minSelect?: number;
  }[];
}

export interface Allergy {
  url: string;
  content: string;
}

export interface LegalNotice {
  images: any[];
  origin: Allergy;
  nutrient: Allergy;
  allergy: Allergy;
  useMenuCode: number;
  requireMenuCode: number;
  isPrintOrigin: string;
  originDisplay: string;
}

export interface Products {
  storeIsLink: string;
  useMenuCode: number;
  useMenuCodeEcoupon: number;
  categoryID: string;
  categoryName: string;
  ID: string;
  name?: string;
  productDescription: string;
  menuCouponCount: number;
  status: string;
  isDisplay: string;
  recommend: string;
  alcohol: string;
  imageUrl: string;
  options: ProductsOption[];
}

export interface ProductsOption {
  optionGroupID: number;
  isPriceOption: string;
  title: string;
  type: number;
  limitChildren: number;
  isRequired: number;
  minSelect: number;
  maxSelect: number;
  isDisplay: number;
  children: (ProductsChild | InitProductChild)[];
}

export interface ProductsChild {
  optionID: string;
  name: string;
  originPrice: number | string;
  price: number | string;
  isPromotion: number;
  externalMenuCode: string;
  status: string;
  isDisplay: string;
  alcohol: string;
  maxSelect: number;
  ecouponVendorID: string;
  ecouponMenuCode: string;
  menuCouponCount: number;
}

export interface InitProduct {
  name?: string;
  productDescription: string;
  status: string;
  isDisplay: string;
  recommend: string;
  alcohol: string;
  imageUrl: string;
  options: {
    isPriceOption: string;
    title: string;
    type: number;
    children: InitProductChild[];
  }[];
}

export interface InitProductChild {
  alcohol?: string;
  name: string;
  originPrice?: number | string;
  price: number | string;
  isDisplay?: string;
  menuCouponCount?: number;
}

export const MENUTYPE = {
  origin: '0',
  alcohol: '1',
};

export interface SimpleCategory {
  categoryID: string;
  categoryName: string;
  description: string;
  represent: boolean;
  categoryFold: string;
  beginDate: Date;
  beginTime: string;
  endDate: Date;
  endTime: string;
  day: ConditionDay[];
  displayType: string;
  isPass: boolean;
}

export interface SortableItemProps {
  list: SimpleCategory | Product | ProductsOption;
  index: number;
}

export interface SortableListProps {
  items: (SimpleCategory | Product | ProductsOption)[];
}

export const PRODUCT_KEYS = {
  PERMISSION: 'menuPermission',
  STORE: 'storeList',
  CATEGORY: 'category',
  OPTIONGROUP: 'optionGroup',
  LEGALNOTICE: 'legalNotice',
  PRODUCT: 'product',
  PRODUCTOPTIONGROUP: 'productOptionGroup',
  SIMPLECATEGORY: 'simpleCategory',
  OPTIONGROUPDETAIL: 'optionGroupDetail',
  PRODUCTRECOMMEND: 'productRecommend',
};
